import { useNode } from "@craftjs/core";
import { FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import { SettingCard } from "@/components";
import NewColorPicker from "@/components/editor/settings/ColorSettings";

const InputIconSettings = () => {
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props,
  }));

  return (
    <Stack spacing={2}>
      <SettingCard title="Icono">
        <Stack spacing={2}>
          {/* Icon Name */}
          <TextField
            label="Nombre del Icono (Hugeicon)"
            size="small"
            helperText="Ej: Mail01Icon"
            value={props.icon || ""}
            onChange={(e) =>
              setProp((props: any) => {
                props.icon = e.target.value;
              })
            }
          />

          {/* Icon Location */}
          <FormControl fullWidth size="small">
            <InputLabel>Ubicación</InputLabel>
            <Select
              label="Ubicación"
              value={props.iconLocation || "start"}
              onChange={(e) =>
                setProp((props: any) => {
                  props.iconLocation = e.target.value;
                })
              }
            >
              <MenuItem value="start">Inicio (Start)</MenuItem>
              <MenuItem value="end">Fin (End)</MenuItem>
            </Select>
          </FormControl>

          <Stack direction="row" spacing={2}>
            {/* Icon Size */}
            <TextField
              label="Tamaño"
              size="small"
              type="number"
              value={props.iconSize || 20}
              onChange={(e) =>
                setProp((props: any) => {
                  props.iconSize = parseInt(e.target.value, 10);
                })
              }
            />

            {/* Icon Stroke */}
            <TextField
              label="Grosor"
              size="small"
              type="number"
              value={props.iconStroke || 2}
              onChange={(e) =>
                setProp((props: any) => {
                  props.iconStroke = parseFloat(e.target.value);
                })
              }
              inputProps={{ step: 0.5, min: 0.5, max: 5 }}
            />
          </Stack>

          {/* Icon Color */}
          <NewColorPicker field="iconColor" />
        </Stack>
      </SettingCard>
    </Stack>
  );
};

export default InputIconSettings;
